const DEFAULT_APP_SHELL_CONFIG = {
    showAnnouncement: true,
    showNavbar: true,
    showFooter: true,
    showFloatingChat: true,
};

function normalizePathname(pathname) {
    if (typeof pathname !== 'string' || pathname.length === 0) {
        return '';
    }

    return pathname.split('?')[0].split('#')[0];
}

function isAdminLoginPath(pathname) {
    return pathname === '/admin/login' || pathname.startsWith('/admin/login/');
}

function isAdminPath(pathname) {
    return pathname === '/admin' || pathname.startsWith('/admin/');
}

export function getAppShellConfig(pathname) {
    const normalizedPathname = normalizePathname(pathname);

    if (!normalizedPathname) {
        return DEFAULT_APP_SHELL_CONFIG;
    }

    if (isAdminLoginPath(normalizedPathname)) {
        return {
            ...DEFAULT_APP_SHELL_CONFIG,
            showAnnouncement: false,
            showFooter: false,
            showFloatingChat: false,
        };
    }

    if (isAdminPath(normalizedPathname)) {
        return {
            ...DEFAULT_APP_SHELL_CONFIG,
            showAnnouncement: false,
            showFloatingChat: false,
        };
    }

    return DEFAULT_APP_SHELL_CONFIG;
}

export function shouldUsePublicAppShell(pathname) {
    const config = getAppShellConfig(pathname);

    return Object.values(config).some(Boolean);
}
